(function($, undefined) {
	
	'use strict';
	var XMLUtils;
	var utils;
	var textSelector;
	
	var cache = {
		"answer" : null	
	};

	var validateTextSelector = function(e) {
		var item = $(this);
		if (!item.hasClass('error') && !item.hasClass('success') && !$(e.target).hasClass('lexique-word')) {
			item.closest('.text-selector-item-student').addClass('processing');
			var clickedAnswer = item.attr('data-index');
			
			getCorrectAnswer(function(answer) {
				item.closest('.text-selector-item-student').removeClass('processing');
				if (clickedAnswer === answer) {
					item.addClass('success');
					updateUIRightAnswer();
				}
				else {
					item.addClass('error');
					updateUIWrongAnswer();
				}
				$('.exercise-detail-ctn').trigger('exercise-state-change');
			});
		}
	};
	
	var updateUIWrongAnswer = function() {
		var currentTries = 3;
		if ($('.exercise-tries-left')) {
			currentTries = parseInt($('.exercise-tries-left .num').first().text());
			if (currentTries > 0) {
				$('.exercise-tries-left .num').text(currentTries - 1);
			}
		}
		
		if (!$('.exercise-tries-left') || currentTries - 1 <= 0) {
			$('.texts-selector-student-ctn-inner').find('.show-right-answer-btn').removeAttr('disabled');
			$('.items-selector-items-wrapper').addClass('disabled');
		}
	};
	
	var updateUIRightAnswer = function() {
		$('.texts-selector-student-ctn-inner').find('.show-right-answer-btn').hide();
		$('.save-exercise-btn').removeAttr('disabled');
	};
	
	var showValidAnswer = function() {	
		getCorrectAnswer(function(index) {
			$('.text-selector-item-student').eq(index - 1).addClass('success');
			updateUIRightAnswer();
		});
	};

	var getCorrectAnswer = function(callback) {
		if (cache.answer !== null) {
			callback(cache.answer);
		} 
		else {
			utils.getGenData($('.exercise-detail-ctn').attr('data-id'), function(json) {
				var xml = XMLUtils.stringToXML(json);
				var textNodes = xml.getElementsByTagName('TextSelectorItem');
				
				var answer = null;
				for (let i = 0; i < textNodes.length; i++) {
					if (textNodes[i].getAttribute('isAnswer') == 'true') {
						answer = textNodes[i].getAttribute('index');
						break;
					}
				}				
				cache.answer = answer;
				callback(answer);
			});
		}
	};
	
	var init = function () {
		XMLUtils = Fw.component.models().XMLUtils;
		utils = Fw.component.models().utils;
		textSelector = $('.text-selector-item-student');
		
		textSelector.on('click', validateTextSelector);
		$('.texts-selector-student-ctn .show-right-answer-btn').on('click', showValidAnswer);
		
		$('.text-selector-item-student').each(function(i, el) {
			var element = $(el).find('.text-ctn');
			utils.loadLexiqueText(element.html(), function(text) {
				element.html(text);	
				element.removeClass('processing hide');
			});
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
